import styled from 'styled-components';

export const StyledTitle = styled.h5`
    font-weight: 300;
    font-size: 12px
    padding: 0 1.5rem;
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 17px;
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ theme }) => theme.components.bottomSheet.header.textColor}
`;
